// ScheduleItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDom from 'react-dom'
import classnames from 'classnames'

import Util from '../../../lib/util.jsx'
import Input from '../../../common/form/input/input.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'

class ScheduleItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dataDate: null,
      active: false,
      timeTakenText: this._formatTimeForInput(props.availableTime)
    }

    this._saveTime = null

    this._references = {
      timeInput: React.createRef()
    }
  }

  static get propTypes () {
    return {
      label: PropTypes.string,
      availableTime: PropTypes.number,
      className: PropTypes.string,
      onSaveTime: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      label: '',
      availableTime: 0,
      onChangeTime: null,
      className: '',
      onSaveTime: null
    }
  }

  componentDidMount () {
    window.rootApp.addEventListener('click', this._handleDocumentClick)
  }

  componentWillUnmount () {
    window.rootApp.removeEventListener('click', this._handleDocumentClick)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    const stateObj = {}
    if (nextProps.availableTime !== this.props.availableTime) {
      stateObj.timeTakenText = nextProps.availableTime
        ? this._formatTimeForInput(nextProps.availableTime)
        : '0:00'
    }

    this.setState(stateObj)
  }

  componentDidUpdate (prevProps, prevState) {
    if (
      this._references.timeInput.current &&
      this.state.active &&
      prevState.active !== this.state.active
    ) {
      this._references.timeInput.current.focus()
    }
  }

  _handleDocumentClick = evt => {
    if (this.state.active) {
      const area = ReactDom.findDOMNode(this)
      if (!area.contains(evt.target)) {
        this.onCloseForm()
      }
    }
  }

  render () {
    const _className = classnames(
      'schedule-item',
      {
        active: this.state.active
      },
      this.props.className
    )
    const timeOptions = [
      {
        label: 'user.schedule.labelZeroHours',
        title: 'user.schedule.titleAddZeroHours',
        value: 0
      },
      {
        label: 'user.schedule.labelFourHours',
        title: 'user.schedule.titleAddFourHours',
        value: 240
      },
      {
        label: 'user.schedule.labelEightHours',
        title: 'user.schedule.titleAddEightHours',
        value: 480
      }
    ]

    return (
      <div className={_className}>
        <div className='cont'>
          <div className='innercont' onClick={this._onClickItem.bind(this)}>
            <span className='day'>{this.props.label}</span>
            <span className='time'>{this.state.timeTakenText}</span>
            <span className='info'>
              <IntlMessage ident='user.schedule.hourInfo' />
            </span>
          </div>
          <div className='activecont'>
            <div className='action'>
              <Input
                type='text'
                name='time'
                label='time.item.labelTimeInput'
                className='schedule-input'
                value={this.state.timeTakenText}
                size={10}
                maxLength={100}
                validations={['required']}
                ref={this._references.timeInput}
                onChange={this._onChangeTimeTaken.bind(this)}
                onBlur={this._onBlurTimeTaken.bind(this)}
                onKeyDown={this._onKeyPressInput.bind(this)}
              />
            </div>
            <div className='timebuttons'>
              {timeOptions.map((timeOpt, idx) => (
                <div
                  title={IntlUtil.convertMessage(timeOpt.title)}
                  className='timebutton'
                  key={idx}
                  onClick={this._onIncrementTime.bind(this, timeOpt.value)}
                >
                  <IntlMessage ident={timeOpt.label} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onKeyPressInput (ev) {
    if (ev.keyCode === 13 || ev.keyCode === 9 || ev.keyCode === 27) {
      this.onCloseForm()
    }
  }

  _onChangeTimeTaken (value) {
    if (!/^[0-9]{0,2}(:)*[0-9]{0,2}$/.test(value)) {
      this.forceUpdate()
    } else {
      let timeTaken = 0
      const timeArr = value.split(':')
      if (timeArr.length > 1) {
        timeTaken =
          (timeArr[0] ? parseInt(timeArr[0], 10) : 0) * 60 +
          (timeArr[1] ? parseInt(timeArr[1], 10) : 0)
      } else {
        timeTaken = parseInt(timeArr[0], 10) * 60
      }

      const newTimeTaken = this._updateTimeTaken(timeTaken)
      if (newTimeTaken !== timeTaken) {
        this.setState({
          timeTakenText: this._formatTimeForInput(newTimeTaken),
          dataDate: new Date()
        })
      } else {
        this.setState({ timeTakenText: value })
      }
    }
  }

  _onBlurTimeTaken () {
    if (!/^[0-9]{0,2}(:)*[0-9]{0,2}$/.test(this.state.timeTakenText)) {
      this.forceUpdate()
    } else {
      let timeTaken = 0
      const timeArr = this.state.timeTakenText.split(':')
      if (timeArr.length > 1) {
        timeTaken =
          (timeArr[0] ? parseInt(timeArr[0], 10) : 0) * 60 +
          (timeArr[1] ? parseInt(timeArr[1], 10) : 0)
      } else {
        timeTaken = parseInt(timeArr[0], 10) * 60
      }

      this.setState({ timeTakenText: this._formatTimeForInput(timeTaken) })
    }
  }

  _onClickItem (_ev) {
    this.setState({ active: true, dataDate: new Date() })
  }

  onCloseForm () {
    this.setState({ active: false, dataDate: new Date() })
  }

  _onIncrementTime (incrValue) {
    if (!/^[0-9]{0,2}(:)*[0-9]{0,2}$/.test(this.state.timeTakenText)) {
      this.forceUpdate()
    } else {
      const newTimeTaken = this._updateTimeTaken(incrValue)
      this.setState({ timeTakenText: this._formatTimeForInput(newTimeTaken) })
      if (this._references.timeInput.current) {
        this._references.timeInput.current.focus()
      }
    }
  }

  _updateTimeTaken (timeTaken) {
    timeTaken = timeTaken > 24 * 60 ? 24 * 60 : timeTaken

    if (this._saveTime) window.clearTimeout(this._saveTime)

    this._saveTime = window.setTimeout(() => {
      this.props.onSaveTime(timeTaken || 0)
    }, 500)

    return timeTaken
  }

  _formatTimeForInput (timeTaken) {
    if (timeTaken === 0) {
      return '0:00'
    }

    return timeTaken ? Util.convertMinutesToHour(timeTaken) : ''
  }
}

export default ScheduleItem
